import { render, staticRenderFns } from "./EditorIcon.vue?vue&type=template&id=413a60c5&scoped=true"
import script from "./EditorIcon.vue?vue&type=script&lang=js"
export * from "./EditorIcon.vue?vue&type=script&lang=js"
import style0 from "./EditorIcon.vue?vue&type=style&index=0&id=413a60c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413a60c5",
  null
  
)

export default component.exports